<script setup>
import TrustpilotWidget from '@components-molecules/TrustpilotWidget.vue';
import ProfilePictures from '@components-molecules/ProfilePictures.vue';
import { trans } from '@elements/translation';

const { COMPANY_NAME } = window;

const pictures = [
  {
    alt: 'Chloe',
    uuid: '7cb83085-c0a4-4e04-9079-d6606184fba0',
  },
  {
    alt: 'Paul V',
    uuid: '934a6318-5cc4-4592-9e15-860540550fef',
  },
  {
    alt: 'Martin',
    uuid: '7203c5c8-13e1-41cc-b114-d898d50937d8',
  },
];
</script>

<template>
  <div class="space-promises">
    <div class="space-promises__section">
      <ProfilePictures :medias="pictures" />

      <div class="space-promises__response-time">
        <span class="space-promises__response-time__icon" />

        <p class="space-promises__response-time__text">
          {{ trans('space.contact.promises.speed_time', { company_name: COMPANY_NAME }) }}
        </p>
      </div>
    </div>

    <TrustpilotWidget
      class="space-promises__trustpilot"
      type="trust_score"
      width="250"
    />
  </div>
</template>
